import _ from 'lodash';
import initialState from './initialState.js';
import constants from '../helpers/constants.js';

export default function bootReducer(state = initialState.bootData, action) {
    switch (action.type) {
        case constants.GET_BOOT_SETTINGS:
            return Object.assign({}, state, { settings: action.data });
        case constants.GET_FEATURE_VERSION:
            return Object.assign({}, state, { features: action.data });
        case constants.GET_LANGUAGE_TRANSLATION:
            return Object.assign({}, state, { translation: action.data });
        case constants.GET_SCREEN_OVERLAY:
            return Object.assign({}, state, { screenOverlay: action.data });
        case constants.PORTAL_TILES:
            return Object.assign({}, state, { portalTile: action.data });
        case constants.SHOW_SPINNER:
            return Object.assign({}, state, { showSpinner: action.data });
        case constants.INCREMENT_LOADING_ELEMENTS:
            return Object.assign({}, state, {
                waitingForAPICall: state.waitingForAPICall + 1,
                showSpinner: true,
            });
        case constants.DECREMENT_LOADING_ELEMENTS:
            return Object.assign({}, state, {
                waitingForAPICall: state.waitingForAPICall - 1,
                showSpinner: state.waitingForAPICall - 1 > 0,
            });
        default:
            return state;
    }
}
